<template>
  <svg class="custom-icon" aria-hidden="true">
    <use :xlink:href="`#icon-${name}`"></use>
  </svg>
</template>

<script>
export default {
  name: "CustomIcon",
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.custom-icon {
  /* 自定义图标的样式 */
}
</style>



// WEBPACK FOOTER //
// src/components/CustomIcon/index.vue